export default __webpack_public_path__ + "static/media/icon-grid-view-selected.a80d950d.svg";